module.exports = __webpack_public_path__ + "img/ab-mobile-hover.648d3901.png";